<template>
  <div>
    <b-card class="m-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center">
          <b-button
            class="float-right m-1"
            size="sm"
            variant="outline-secondary"
            :disabled="baixandoPecaUnica"
            @click="baixarDocumento"
          >
            <b-spinner
              v-if="baixandoPecaUnica"
              small
              class="mx-1 mx-sm-0 mr-sm-2"
            />
            <font-awesome-icon
              v-else
              icon="file-pdf"
              class="mx-1 mx-sm-0 mr-sm-2"
            />
            <span class="d-none d-sm-inline">
              {{ baixandoPecaUnica ? "Baixando..." : tituloBotaoDownload }}
            </span>
          </b-button>
          <span class="titulo-sagres font-weight-bold">
            Detalhes da comunicação eletrônica
          </span>
          <btn-voltar url="/processo-eletronico/comunicacoes-eletronicas" />
          <b-button v-if="podeResponder" class="float-right m-1" size="sm" @click="responderAComunicacaoEletronica">
            <font-awesome-icon icon="edit" class="mr-2" />
            Responder
          </b-button>
        </h6>
      </template>
      <b-card-body>
        <!-- <span>{{ notificacao }}</span> -->
        <dados-comunicacao-eletronica :notificacao="notificacao" />
      </b-card-body>
    </b-card>
    <lista-multimidia :lista="listaMultimidia" />
    <modal-pdf
      v-if="exibirModalPdfPecaUnica && pdfDataPecaUnica"
      @fecharModal="exibirModalPdfPecaUnica = false"
      :pdfData="pdfDataPecaUnica"
      :filename="nomeArquivoDocumento"
      :titulo="tituloModalPdf"
    />
  </div>
</template>

<script>
import protocoloService from "@/services/processos-eletronicos/protocoloService";
import BtnVoltar from "@/components/shared/BtnVoltar.vue";
import ListaMultimidia from "@/components/processo-eletronico/ListaMultimidia.vue";
import DadosComunicacaoEletronica from "@/components/processo-eletronico/comunicacoes-eletronicas/DadosComunicacaoEletronica.vue";
import ModalPdf from "@/components/ModalPdf.vue";
import {
  montarNomeArquivoPecaUnica,
  montarNomeArquivoAto,
  processarAto,
  processarPecaUnica,
  podeVisualizarPecaUnica,
} from "@/utils/peca-unica";
import { store } from "@/store";
import { UtilsTS } from '@/utilsts';

export default {
  name: "DetalhesComunicacaoEletronica",
  props: ["notificacao"],
  mixins: [UtilsTS],
  components: { BtnVoltar, DadosComunicacaoEletronica, ListaMultimidia, ModalPdf },
  data() {
    return {
      listaMultimidia: null,
      exibirModalPdfPecaUnica: false,
      pdfDataPecaUnica: null,
      baixandoPecaUnica: false,
    };
  },
  computed: {
    exibePecaUnica() {
      return this.notificacao?.ExibePecaUnica !== false;
    },
    // podeVisualizarDocumento() {
    //   if (!this.exibePecaUnica) {
    //     return Boolean(String(this.notificacao?.CodArquivoDigitalCriptografado || "").trim());
    //   }

    //   return podeVisualizarPecaUnica({
    //     codProtocoloCriptografado: this.notificacao?.CodProtocoloCriptografado,
    //     tipo: this.notificacao?.Tipo,
    //     codigoTipoDocumento: this.notificacao?.CodigoTipoDocumento,
    //   });
    // },
    tituloBotaoDownload() {
      return this.exibePecaUnica ? "Peça Única" : "Ato";
    },
    nomeArquivoPecaUnica() {
      return montarNomeArquivoPecaUnica(
        this.notificacao?.Tipo || "processo",
        this.notificacao?.CodTCE || this.notificacao?.Notificacao
      );
    },
    nomeArquivoDocumento() {
      return this.exibePecaUnica
        ? this.nomeArquivoPecaUnica
        : montarNomeArquivoAto(this.notificacao?.CodArquivoDigitalCriptografado);
    },
    tituloModalPdf() {
      return this.exibePecaUnica ? "Ver Processo" : "Ver Ato";
    },
    podeResponder() {
      return (
        this.notificacao &&
        this.notificacao.PermiteResposta &&
        !this.notificacao.DataResposta &&
        !this.notificacao.DataRespostaPrazo
      );
    },
  },
  methods: {
    /*sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },*/
    responderAComunicacaoEletronica() {
      this.$router.push({
        name: "ResponderComunicacaoEletronica",
        params: { notificacao: this.notificacao },
      });
    },
    async baixarDocumento() {
      this.baixandoPecaUnica = true;
      try {
        const resultado = this.exibePecaUnica
          ? await processarPecaUnica(this.notificacao?.CodProtocoloCriptografado)
          : await processarAto(this.notificacao?.CodArquivoDigitalCriptografado);
        if (resultado.acao === "download") {
          this.download(`${this.nomeArquivoDocumento}.pdf`, resultado.arquivo);
          return;
        }
        this.pdfDataPecaUnica = resultado.pdfData;
        this.exibirModalPdfPecaUnica = true;
      } catch (err) {
        this.tratarError(err);
      } finally {
        this.baixandoPecaUnica = false;
      }
    },
    async getDetalhesCI() {
      try {
        store.blockScreen = true;
        const data = new FormData();
        data.append("codNotificacao", this.notificacao.Codigo);
        data.append("codProtocolo", this.notificacao.CodProtocolo);

        //aqui será chamado o endpoint que marca uma CP como lida e recebe a lista de multimídias
        const response = await protocoloService.visualizarNotificacao(data);

        //console.log(response.data);
        if (response && response.status == 200) {
          this.listaMultimidia =
            response.data && response.data.length ? response.data : null;
        } else {
          this.$toast.error("Erro ao obter multimídias desta comunicação.");
        }
      } catch (err) {
        console.error("Erro ao obter detalhes da Comunicação Eletrônica: ", err);
        this.$toast.error(err.message);
      } finally {
        store.blockScreen = false;
      }
    },
  },
  async mounted() {
    await this.getDetalhesCI();
  },
};
</script>
<style scoped>
div.row>div>span:first-child {
  font-weight: bolder;
  display: block;
}
</style>
